// @ts-nocheck
import React, { Component } from 'react';

// modules
import { COLOR, BLOCK } from "../../modules/constants"

// mui
import { Box, Typography } from '@mui/material'
import { withStyles } from '@mui/styles'

const styles = theme => ({
  root: {
  },
  dataCard: {
    width: "auto",
    lineHeight: 1,
    padding: `${BLOCK.PADDING_VERT}px 0px ${BLOCK.PADDING_VERT}px 0px`,
    backgroundColor: COLOR.BACKGROUND,
  },
  dataItem: {
    width: "auto",
  },
  title: {
    fontSize: 12,
    fontWeight: "bold",
    lineHeight: 1,
  },
  dataId: {
    fontSize: 9,
    color: "grey",
    marginTop: 5,
    lineHeight: 1,
  },
  dataValue: {
    fontSize: BLOCK.FONT_SIZE,
    fontWeight: "normal",
    lineHeight: 1.2,
  }
})

const createRow = (classes, item, index, fontSize) =>
  <Box key={index} id={item.id} className={classes.dataItem}>
    <Typography className={classes.dataId} style={{ fontSize: 9, color: "grey", marginTop: 5, marginBottom: 0, lineHeight: 1 }}>{item.id}</Typography>
    <Typography className={classes.dataValue} style={{ color: item.color, fontSize, fontWeight: "normal", marginTop: 1, lineHeight: 1.3 }}>{item.value}</Typography>
  </Box>

class DataCard1xN extends Component {
  render() {
    const { classes, title, dataItems, valueFontSize: fontSize } = this.props

    return (
      <Box id="data-card" className={classes.dataCard}>
        {title && <Typography className={classes.title} >{title}</Typography>}
        {dataItems.map((dataItem, index) => createRow(classes, dataItem, index, fontSize))}
      </Box>
    )
  }
}

export default withStyles(styles)(DataCard1xN)

